import React from 'react';
import { UiSelect } from '../ui-kit/UiSelect';

/* eslint-disable react/prop-types */
export function UiSelectAdapter({ input, meta, id, ...rest }) {
  return (
    <UiSelect
      {...input}
      {...rest}
      inputId={id}
      errorMessage={meta.touched ? meta.error || meta.submitError : ''}
    />
  );
}
